import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  TextField,
  Button,
  Container,
  Box,
  IconButton,
  InputAdornment,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useForm } from "react-hook-form";
import Turnstile from "react-turnstile";
import { toast } from "react-toastify";

const users = {
  mihai: { password: "29061976", role: "admin", email: "desarrollo@indiex.es" },
  mariano: { password: "4966SIgr", role: "admin", email: "m.gimeno@indiex.es" },
  oscar: { password: "4966SIgr", role: "admin", email: "informatica@lifepro.es" },
  mariaj: { password: "4966SIgr", role: "admin", email: "informatica07@lifepro.es" },
  attclientes: { password: "uL5xdtYtU", role: "manager", email: "att.clientes@indiex.es" },
  administracion: { password: "P30111512m", role: "manager", email: "administracion@indiex.es" },
  finanzas: { password: "5nw3k2zD", role: "manager", email: "finanzas@indiex.es" },
  rrhh: { password: "zDYZrp3Ic", role: "manager", email: "rrhh@indiex.es" },
  almacen: { password: "1975juanjo1975", role: "manager", email: "almacen@indiex.es" },
  mpcompras: { password: "1975mpcompras", role: "manager", email: "mpcompras@indiex.es" },
  mantenimiento: { password: "1975manchechu", role: "manager", email: "mantenimiento@indiex.es" },
  mcontinua: { password: "1975mcontinua", role: "manager", email: "mcontinua@lifepronutrition.com" },
  orders: { password: "x4tMqTfhj", role: "manager", email: "orders@indiex.es" },
  razola: { password: "ETfgouhb2idc6b", role: "manager", email: "d.razola@sportnutritionlaboratory.com" },
  ivan: { password: "1975ivan1975", role: "manager", email: "almacen@lifepro.es" },
  marketing: { password: "21188aasd", role: "manager", email: "marketing@indiex.es" },
  limpieza: { password: "8FPuTqmjNgXpWt9", role: "manager", email: "limpieza@lifepro.es" },
  calidad: { password: "calidad4966", role: "admin", email: "calidad@indiex.es" }
};

const Login = () => {
  const { register, handleSubmit, setValue, getValues } = useForm();
  const [token, setToken] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (data) => {
    if (!token) {
      toast.error("Por favor, completa el CAPTCHA.");
      return;
    }

    if (!data.username || !data.password) {
      toast.error("Por favor, completa todos los campos.");
      return;
    }

    const user = users[data.username.toLowerCase()];
    if (user && user.password === data.password) {
      localStorage.setItem("auth", "true");
      localStorage.setItem("role", user.role);
      if (user.email) {
        localStorage.setItem("userEmail", user.email);
      } else {
        localStorage.removeItem("userEmail");
      }
      localStorage.setItem("username", data.username.toLowerCase());
      toast.success("Inicio de sesión exitoso.");
      setTimeout(() => navigate("/"), 1500);
    } else {
      toast.error("Usuario o contraseña incorrectos.");
    }
  };

  const handleUsernameChange = (e) => {
    const lowercaseValue = e.target.value.toLowerCase();
    setValue("username", lowercaseValue);
  };

  return (
    <Container maxWidth="xs">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "calc(100vh - 285px)",
        }}
        className="inicio"
      >
        <img
          src="/life-pro-nutrition-logo.svg"
          alt="Life Pro Nutrition"
          style={{ width: "200px", marginBottom: "20px" }}
        />
        <Box sx={{ width: 300 }}>
          <form onSubmit={handleSubmit(onSubmit)} style={{ width: "100%" }}>
            <TextField
              fullWidth
              label="Usuario"
              margin="normal"
              {...register("username")}
              onChange={handleUsernameChange}
            />
            <TextField
              fullWidth
              label="Contraseña"
              margin="normal"
              type={showPassword ? "text" : "password"}
              {...register("password")}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
              <Turnstile
                sitekey={process.env.REACT_APP_TURNSTILE_SITE_KEY}
                onVerify={(token) => setToken(token)}
              />
            </Box>
            <Button type="submit" fullWidth variant="contained" sx={{ mt: 2 }}>
              Entrar
            </Button>
          </form>
        </Box>
      </Box>
    </Container>
  );
};

export default Login;
